import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = {
  key: 0,
  class: "flex-center py-10"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-danger mb-4"
}
const _hoisted_4 = { class: "widget edit-card" }
const _hoisted_5 = { class: "progress-bar mb-6" }
const _hoisted_6 = { class: "progress-bar-percent" }
const _hoisted_7 = {
  key: 0,
  class: "text-center text-grey-500 py-5"
}
const _hoisted_8 = {
  key: 1,
  class: "prelevements-grid"
}
const _hoisted_9 = { class: "prelevement-head" }
const _hoisted_10 = { class: "font-semibold mb-1" }
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = { class: "prelevement-meta" }
const _hoisted_13 = {
  key: 0,
  class: "text-sm text-grey-500 mt-2 mb-3"
}
const _hoisted_14 = {
  key: 1,
  class: "text-sm text-grey-500 mt-2 mb-3"
}
const _hoisted_15 = ["disabled", "onClick"]
const _hoisted_16 = {
  key: 0,
  class: "btn-show"
}
const _hoisted_17 = {
  key: 1,
  class: "btn-loading"
}

import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import MemberInfoHeader from '@/components/collectivites/MemberInfoHeader.vue';
import membersService from '@/services/membersService';
import { formatAmount, formatDateFrench } from '@/utils/formatters';
import { showAlert, showConfirm } from '@/utils/swal';


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectiviteMembrePlan',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const memberId = computed(() => Number(route.params.id));
const member = ref<any>(null);
const items = ref<any[]>([]);
const stats = ref({ total_attendu: 0, total_effectue: 0, percent: 0 });
const loading = ref(false);
const validatingId = ref<number | null>(null);
const errorMessage = ref('');

function goBack() {
    router.push({ name: 'collectivites-membres' });
}

const monthsFr = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

function moisLabel(detail: any): string {
    if (detail.date_prevision) {
        const d = new Date(detail.date_prevision);
        if (!isNaN(d.getTime())) return `${d.getDate().toString().padStart(2, '0')} ${monthsFr[d.getMonth()]} ${d.getFullYear()}`;
    }
    if (typeof detail.mois === 'number') return `Mois ${detail.mois}`;
    return '-';
}

async function loadAll() {
    if (!memberId.value) return;
    loading.value = true;
    errorMessage.value = '';
    try {
        const [m, p] = await Promise.all([
            membersService.getMember(memberId.value),
            membersService.getMemberPrelevementsMensuels(memberId.value),
        ]);
        member.value = m;
        items.value = p?.items || [];
        stats.value = p?.stats || { total_attendu: 0, total_effectue: 0, percent: 0 };
    } catch (e: any) {
        errorMessage.value = e?.message || 'Erreur lors du chargement.';
    } finally {
        loading.value = false;
    }
}

async function validateDetail(detail: any) {
    const ok = await showConfirm(
        `Valider ce prélèvement de ${formatAmount(detail.montant)} F ?`,
        'Confirmation'
    );
    if (!ok) return;

    validatingId.value = detail.id;
    try {
        await membersService.validateMemberPrelevementMensuel(memberId.value, detail.id);
        await showAlert.success('Prélèvement validé avec succès.');
        await loadAll();
    } catch (e: any) {
        showAlert.error(e?.message || 'Erreur lors de la validation.');
    } finally {
        validatingId.value = null;
    }
}

onMounted(loadAll);

const headerProgress = computed(() => ({
    label: 'Prélèvement',
    percent: stats.value.percent || 0,
    valueLabel: `${Math.round(stats.value.percent || 0)}%`,
}));

function statutTag(statut: string) {
    if (statut === 'done') return { class: 'notif', label: 'Effectué' };
    if (statut === 'cancelled') return { class: 'danger', label: 'Annulé' };
    return { class: 'warning', label: 'En attente' };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", { class: "d-flex align-items-center gap-4 mb-6" }, [
      _createElementVNode("button", {
        class: "btn white2",
        onClick: goBack
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("img", {
          src: "/public/icons/icon-back.svg",
          class: "btn-icon",
          alt: ""
        }, null, -1),
        _createElementVNode("span", null, "Retour", -1)
      ]))]),
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-0" }, "Membre · Plan mensuel", -1))
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "loader dark" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createVNode(MemberInfoHeader, {
      member: member.value,
      "end-date": member.value?.souscription?.date_fin,
      progress: headerProgress.value
    }, null, 8, ["member", "end-date", "progress"]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "edit-card-title" }, [
        _createElementVNode("img", {
          src: "/public/icons/icon-data.svg",
          class: "size-base",
          alt: ""
        }),
        _createTextVNode(" Prélèvement mensuel ")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "progress-bar-fill bg-pop-green",
          style: _normalizeStyle(`width: ${Math.max(2, Math.min(100, stats.value.percent || 0))}%;`)
        }, _toDisplayString(_unref(formatAmount)(stats.value.total_effectue)) + " F / " + _toDisplayString(_unref(formatAmount)(stats.value.total_attendu)) + " F ", 5),
        _createElementVNode("span", _hoisted_6, _toDisplayString(Math.round(stats.value.percent || 0)) + "%", 1)
      ]),
      (items.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Aucun prélèvement prévu. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (detail) => {
              return (_openBlock(), _createElementBlock("div", {
                key: detail.id,
                class: _normalizeClass(["prelevement-card", { done: detail.statut === 'done' }])
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h6", _hoisted_10, _toDisplayString(moisLabel(detail)), 1),
                  _createElementVNode("h3", _hoisted_11, _toDisplayString(_unref(formatAmount)(detail.montant)) + " F", 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["tag-state stroke", statutTag(detail.statut).class])
                  }, _toDisplayString(statutTag(detail.statut).label), 3),
                  (detail.date_operation)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Le " + _toDisplayString(_unref(formatDateFrench)(detail.date_operation)), 1))
                    : (detail.countdown)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(detail.countdown), 1))
                      : _createCommentVNode("", true),
                  (detail.statut === 'pending')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn-ultra w-100",
                        disabled: validatingId.value === detail.id,
                        onClick: ($event: any) => (validateDetail(detail))
                      }, [
                        (validatingId.value !== detail.id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[3] || (_cache[3] = [
                              _createElementVNode("img", {
                                src: "/public/icons/icon-valider.svg",
                                class: "btn-icon",
                                alt: ""
                              }, null, -1),
                              _createElementVNode("span", null, "Valider", -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[4] || (_cache[4] = [
                              _createElementVNode("div", { class: "loader-dots" }, null, -1)
                            ]))]))
                      ], 8, _hoisted_15))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            }), 128))
          ]))
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "clear-both h-50" }, null, -1))
  ]))
}
}

})